import { validateEmail, validateCnpj, validatePhone, validateIE } from '@/functions/Util';

export default class DefaultValidation {
    
    constructor(msgs) {
        this._msgs = msgs;
    }

    showMessage(message) {
        if (message && !this._msgs.filter(m => m.message == message.message)[0]) {
            this._msgs.push(message);
        }
    }
    
    validate(model) {
        throw new Error('Method \'validate\' must be implemented!');
    }

    manageCnpjValidation(cnpj, refs) {
        if ( cnpj && !validateCnpj(cnpj) ) {
            refs.cnpjInput.$el.classList.add('invalid');
        } else {
            refs.cnpjInput.$el.classList.remove('invalid');            
        }
    } 

    manageCellPhoneValidation(cphone, refs) {
        if (cphone && !validatePhone(cphone)) {
            refs.celularInput.$el.classList.add('invalid');
        } else {
            refs.celularInput.$el.classList.remove('invalid');            
        }
    }
    managePhoneValidation(phone, refs) {
        if (phone && !validatePhone(phone)) {
            refs.telefoneInput.$el.classList.add('invalid');
        } else {
            refs.telefoneInput.$el.classList.remove('invalid');            
        }
    }
    manageFaxValidation(fax, refs) {
        if (fax && !validatePhone(fax)) {
            refs.faxInput.$el.classList.add('invalid');
        } else {
            refs.faxInput.$el.classList.remove('invalid');            
        }
    }

    manageEmailValidation(mail, refs) {
        if (mail && !validateEmail(mail)) {
            refs.emailInput.classList.add('invalid');
        } else {
            refs.emailInput.classList.remove('invalid');            
        }
    }
    
    manageIEValidation(ie, refs) {
        if (ie && !validateIE(ie)) {
            refs.ieInput.$el.classList.add('invalid');
        } else {
            refs.ieInput.$el.classList.remove('invalid');            
        }
    }

    getRegexValidchars(validchars) {
        /*  Criação da regex a partir do validchars
            *  Resulta em uma regex do tipo /^[\u0020\u0021...]*$]
            *  Em que os caracteres são convertidos em sequencias de escape unicode
            *  Ex: letra "a" = \u0061
            *  Isso é necessário para não conflitar com os caracteres reservados do regex */

        let rgx = "^[#]*$";
        let unc = "";
        let vc_array = validchars.split("");

        vc_array.forEach(c => {
            unc = unc.concat(`\\u${c.charCodeAt(0).toString(16).padStart(4, "0")}`);
        });

        return new RegExp(rgx.replace("#", unc));
    }

}